// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GYG4D60g0IxEPzfHC1dr {
    padding: 8px;
    flex-grow: 1 !important;
    width: 14%;
}

.B3GShPR_XDN0jNfT6KSg {
    height: 50px;
    border-radius: 4px;
    padding: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    background: white;
    cursor: default;
}

.B3GShPR_XDN0jNfT6KSg.vRetSuzOQ6egUDejuWSQ {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.B3GShPR_XDN0jNfT6KSg.vRetSuzOQ6egUDejuWSQ:hover {
    background-color: #f8f9fa;
}

.B3GShPR_XDN0jNfT6KSg.ZYGYF79bgsfSxp6m7NHU {
    border-bottom: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    height: 67px;
    z-index: 999;
}

.B3GShPR_XDN0jNfT6KSg.xw7ptGD8jfHhVCaNU5zP {
    color: #ccc;
    background-color: #fafafa;
}

.MMJDLRinWtN6jQyWmrFR {
    font-weight: 500;
    margin-bottom: 4px;
    color: #333;
    visibility: visible;
}

.B3GShPR_XDN0jNfT6KSg.xw7ptGD8jfHhVCaNU5zP .MMJDLRinWtN6jQyWmrFR {
    color: #ccc;
}

.B3GShPR_XDN0jNfT6KSg:not(.vRetSuzOQ6egUDejuWSQ) .MMJDLRinWtN6jQyWmrFR {
    visibility: hidden;
}

.YW8m3cfZU9FL3jxAuWB2 {
    display: flex;
    gap: 2px;
    margin-top: 4px;
}

.R59g5DhEXbDs2UuVdzXb {
    width: 8px;
    height: 8px;
    border-radius: 2px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Shared/AvailabilityShared/CalendarContent/CalendarDay/CalendarDay.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".wrapper {\n    padding: 8px;\n    flex-grow: 1 !important;\n    width: 14%;\n}\n\n.calendarDay {\n    height: 50px;\n    border-radius: 4px;\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    position: relative;\n    background: white;\n    cursor: default;\n}\n\n.calendarDay.available {\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.calendarDay.available:hover {\n    background-color: #f8f9fa;\n}\n\n.calendarDay.selected {\n    border-bottom: none;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    height: 67px;\n    z-index: 999;\n}\n\n.calendarDay.otherMonth {\n    color: #ccc;\n    background-color: #fafafa;\n}\n\n.dayNumber {\n    font-weight: 500;\n    margin-bottom: 4px;\n    color: #333;\n    visibility: visible;\n}\n\n.calendarDay.otherMonth .dayNumber {\n    color: #ccc;\n}\n\n.calendarDay:not(.available) .dayNumber {\n    visibility: hidden;\n}\n\n.indicators {\n    display: flex;\n    gap: 2px;\n    margin-top: 4px;\n}\n\n.indicator {\n    width: 8px;\n    height: 8px;\n    border-radius: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `GYG4D60g0IxEPzfHC1dr`,
	"calendarDay": `B3GShPR_XDN0jNfT6KSg`,
	"available": `vRetSuzOQ6egUDejuWSQ`,
	"selected": `ZYGYF79bgsfSxp6m7NHU`,
	"otherMonth": `xw7ptGD8jfHhVCaNU5zP`,
	"dayNumber": `MMJDLRinWtN6jQyWmrFR`,
	"indicators": `YW8m3cfZU9FL3jxAuWB2`,
	"indicator": `R59g5DhEXbDs2UuVdzXb`
};
export default ___CSS_LOADER_EXPORT___;
